import React, { Component } from 'react'
import './userinfo.scss'

class UserInfo extends Component {

  render () {
    let user = this.props.user

    if (user === null || user === undefined) return <div />
    return (
      <div className='user-info'>
        <div>{user.Name}</div>
        {user.CompanyName && <div>{user.CompanyName}</div>}
      </div>
    )
  }
}

export default UserInfo



// WEBPACK FOOTER //
// ./src/app/shared/components/UserInfo/index.js